import { ArrayLayoutProps, isObjectArrayWithNesting, RankedTester, rankWith, ControlElement } from "@jsonforms/core";
import { withJsonFormsArrayLayoutProps } from "@jsonforms/react";

import ArrayRendererMain from "../ArrayRenderer/ArrayRenderer";

interface CustomArrayLayoutProps extends ArrayLayoutProps {
	uischema: {
		subText?: string;
		depth?: number;
		headingLevel?: number;
	} & ControlElement;
}

export const CollapsibleArrayLayout = (props: CustomArrayLayoutProps) => (
	<ArrayRendererMain {...props} showAccrordion />
);

export const collapsibleArrayLayoutTester: RankedTester = rankWith(5, isObjectArrayWithNesting);

export default withJsonFormsArrayLayoutProps(CollapsibleArrayLayout);
